import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import { customFormatters } from './customFormatters';
import lazyi18nextBackend from './lazyI18nextBackend';
import ReactPostprocessor from 'i18next-react-postprocessor';
import featureBrancher, {
  setupI18nextFeatureBranching,
} from './featureBrancherPostProcessor';

/**
 * This is the default i18next config used by frontend projects
 *
 * You can provide either single resource or a map of ns to resources
 */
export default function i18n(
  { locale, resources, options = {} },
  debug?: boolean,
  flags?: string[] | null
) {
  const res = { [locale]: { translation: resources } };

  // Allow NS resources to be passed
  if (resources.translation) {
    res[locale] = resources;
  }

  setupI18nextFeatureBranching(flags!, i18next);

  return i18next
    .use(initReactI18next)
    .use(lazyi18nextBackend())
    .use(new ReactPostprocessor())
    .use(featureBrancher)
    .use(customFormatters)
    .init(
      {
        partialBundledLanguages: true, // This is very important, allows mixing of preset and loaded resources
        keySeparator: '$',
        lng: locale,
        fallbackLng: 'en',
        debug,
        interpolation: {
          escapeValue: false,
        },
        postProcess: ['featureBrancher'],
        resources: res,
        ...options,
      },
      undefined
    );
}
